// Day itinerary templates with comprehensive details for each location

import { privateTours } from './privateTours';

export const dayTemplatesByCity = {
  Lisbon: [
    {
      label: "Premium Lisbon Discovery Tour",
      city: "Lisbon",
      isPrivateTour: true,
      tourId: "lisbon-premium",
      slots: {
        allDay: [{
          ...privateTours.lisbon,
          type: 'tour',
          isPrivate: true,
          pois: privateTours.lisbon.detailedItinerary.flatMap(section => section.pois),
          display: {
            badge: "Private Tour",
            badgeColor: "#4f46e5",
            icon: "guide",
            highlights: privateTours.lisbon.highlights,
            detailedSchedule: privateTours.lisbon.detailedItinerary,
            contactInfo: {
              phone: "+351 123 456 789",
              email: "tours@lisbonguides.com"
            }
          },
          duration: privateTours.lisbon.duration,
          price: privateTours.lisbon.price,
          includes: privateTours.lisbon.includes,
          excludes: privateTours.lisbon.excludes,
          meetingPoint: privateTours.lisbon.meetingPoint,
          cancellationPolicy: privateTours.lisbon.cancellationPolicy
        }]
      },
      description: privateTours.lisbon.description,
      tips: [
        "Book at least 48 hours in advance to secure your preferred date",
        "Wear comfortable shoes as there will be some walking",
        "Bring a camera for stunning views of the city"
      ]
    },
    // Regular Templates
    {
      label: "Cultural Lisbon",
      city: "Lisbon",
      slots: {
        morning: [{
          title: "Belém Tower",
          desc: "Iconic 16th-century fortress and UNESCO World Heritage Site at the mouth of the Tagus River.",
          lat: 38.6916,
          lng: -9.2166,
          phone: "+351 21 362 0034",
          hours: "10:00-18:30 (Tue-Sun), Closed Mon",
          price: "€6 (adults), €3 (seniors/students), Free (children under 12)",
          tips: ["Arrive early to avoid crowds", "Buy combo ticket with Jerónimos Monastery for savings", "Great photo spot at sunset"],
          website: "https://www.torrebelem.pt",
          images: ["https://images.pexels.com/photos/5069526/pexels-photo-5069526.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        lunch: [{
          title: "Time Out Market",
          desc: "Renowned food hall featuring 35+ kiosks with top local chefs and fresh products.",
          lat: 38.7083,
          lng: -9.1600,
          phone: "+351 21 395 1274",
          hours: "10:00-00:00 (Sun-Thu), 10:00-02:00 (Fri-Sat)",
          price: "€€",
          tips: ["Try the famous Portuguese custard tarts", "Grab a spot at the central tables for best people-watching", "Great place to sample multiple Portuguese dishes"],
          website: "https://www.timeoutmarket.com/lisboa/",
          images: ["https://images.pexels.com/photos/28208277/pexels-photo-28208277/free-photo-of-time-out-market-lisbon.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        afternoon: [{
          title: "Jerónimos Monastery",
          desc: "Stunning example of Portuguese Late Gothic Manueline architecture, also a UNESCO site.",
          lat: 38.6971,
          lng: -9.2065,
          phone: "+351 21 362 0034",
          hours: "10:00-17:30 (Oct-Apr), 10:00-18:30 (May-Sep), Closed Mon",
          price: "€10 (adults), €5 (seniors/students), Free (children under 12)",
          tips: ["Lines can be long - consider buying tickets online", "Visit the church for free", "The cloisters are the highlight - don't miss them"],
          website: "https://www.mosteirojeronimos.pt",
          images: ["https://images.unsplash.com/photo-1611850333417-0f7fd48df07b?q=80&w=1936&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"]
        }],
        dinner: [{
          title: "Cervejaria Ramiro",
          desc: "Legendary seafood restaurant famous for its garlic shrimp and seafood platters.",
          lat: 38.7170,
          lng: -9.1481,
          phone: "+351 21 885 1024",
          hours: "12:00-00:30 (Tue-Sun), Closed Mon",
          price: "€€€",
          tips: ["Expect to wait - no reservations taken", "Try the prego (steak sandwich) for dessert", "Ask for the daily specials"],
          website: "https://www.cervejariaramiro.pt"
        }],
        evening: [{
          title: "Miradouro da Graça",
          desc: "One of Lisbon's most famous viewpoints with breathtaking panoramas of the city and castle.",
          lat: 38.7145,
          lng: -9.1352,
          hours: "24/7",
          price: "Free",
          tips: ["Best time to visit is sunset", "Small kiosk sells drinks to enjoy with the view", "Less crowded than other viewpoints in the city"]
        }]
      }
    },
    {
      label: "Historic Lisbon",
      city: "Lisbon",
      slots: {
        morning: [{ title: "São Jorge Castle", desc: "Medieval hilltop castle.", lat: 38.7139, lng: -9.1335 }],
        lunch: [{ title: "Alfama District", desc: "Traditional fado quarter.", lat: 38.7139, lng: -9.1256 }],
        afternoon: [{
          title: "Tram 28 Ride",
          desc: "Iconic yellow tram ride through Lisbon's historic neighborhoods.",
          lat: 38.7173,
          lng: -9.1339,
          hours: "06:00-22:30 (varies by season)",
          price: "€3.00 (single ticket)",
          tips: ["Buy a 24-hour public transport pass for unlimited rides", "Ride early morning or late evening to avoid crowds", "Keep an eye on your belongings"],
          images: ["https://images.pexels.com/photos/27583783/pexels-photo-27583783/free-photo-of-a-classic-yellow-tram-in-lisbon.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        dinner: [{
          title: "Pharmacia Restaurant",
          desc: "Creative Portuguese cuisine served in a stylish pharmacy-themed setting with a beautiful terrace.",
          lat: 38.7137,
          lng: -9.1410,
          phone: "+351 21 391 1676",
          hours: "12:30-23:00 (Mon-Sat), 12:30-19:00 (Sun)",
          price: "€€-€€€",
          tips: ["Try their tasting menu for a full experience", "The outdoor terrace has great views of the city", "Reservations recommended for dinner"],
          website: "https://www.pharmacia.pt",
          images: ["https://images.pexels.com/photos/3779791/pexels-photo-3779791.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        evening: [{
          title: "Bairro Alto",
          desc: "Lisbon's most famous nightlife district, known for its vibrant bars, Fado houses, and narrow cobblestone streets lined with colorful buildings.",
          lat: 38.7135,
          lng: -9.1447,
          hours: "Bars typically open 22:00-04:00, Restaurants from 19:00",
          price: "€-€€€ (varies by venue)",
          tips: [
            "Explore the side streets for hidden bars and local spots",
            "Try Ginjinha, a traditional cherry liqueur, at A Ginjinha bar",
            "Visit during the day for great shopping and photo opportunities"
          ],
          images: ["https://images.pexels.com/photos/30235782/pexels-photo-30235782/free-photo-of-colorful-lisbon-alleyway-with-decorated-streets.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }]
      }
    },
    {
      label: "Modern Lisbon",
      city: "Lisbon",
      slots: {
        morning: [{
          title: "Parque das Nações",
          desc: "Lisbon's modern riverside district, originally built for Expo '98, featuring contemporary architecture, scenic promenades, and cultural attractions along the Tagus River.",
          lat: 38.7636,
          lng: -9.0959,
          hours: "24/7 (public areas)",
          price: "Free (public areas)",
          tips: [
            "Walk along the scenic riverside promenade",
            "Ride the cable car for stunning views of the area",
            "Visit the Knowledge Pavilion for interactive science exhibits"
          ],
          website: "https://www.portaldasnacoes.pt",
          images: ["https://images.pexels.com/photos/10959397/pexels-photo-10959397.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        lunch: [{
          title: "Vasco da Gama Shopping",
          desc: "Modern shopping center in Parque das Nações with stunning views of the Tagus River, featuring over 100 shops, restaurants, and entertainment options.",
          lat: 38.7647,
          lng: -9.0950,
          phone: "+351 21 893 0600",
          hours: "10:00-23:00 (Mon-Sat), 11:00-22:00 (Sun & Holidays)",
          price: "€-€€€",
          tips: [
            "Visit the riverside esplanade for great views of the Vasco da Gama Bridge",
            "Try the food court for a variety of Portuguese and international cuisines",
            "Check out the rooftop terrace for panoramic views of the area"
          ],
          website: "https://www.centrovascodagama.pt",
          images: ["https://images.pexels.com/photos/264520/pexels-photo-264520.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        afternoon: [{
          title: "Oceanário de Lisboa",
          desc: "One of the world's largest indoor aquariums, showcasing diverse marine life in carefully recreated habitats.",
          lat: 38.7638,
          lng: -9.0970,
          phone: "+351 21 891 7000",
          hours: "10:00-20:00 (last entry 19:00), Open daily",
          price: "€22 (adults), €15 (seniors/students), €14 (children 4-12), Free (children under 4)",
          tips: [
            "Buy tickets online to skip the queue",
            "Visit during weekdays to avoid crowds",
            "Don't miss the main tank with sharks and rays"
          ],
          website: "https://www.oceanario.pt",
          images: ["https://images.pexels.com/photos/5691144/pexels-photo-5691144.jpeg?auto=compress&cs=tinysrgb&w=600"]
        }],
        dinner: [{
          title: "Maior Restaurante",
          desc: "Elegant restaurant offering refined Portuguese cuisine with a modern twist, featuring a sophisticated ambiance and stunning views of the Tagus River.",
          lat: 38.7630,
          lng: -9.0945,
          phone: "+351 21 893 2220",
          hours: "12:30-15:30, 19:30-23:00 (Tue-Sat), 12:30-15:30 (Sun), Closed Mon",
          price: "€€€€",
          tips: [
            "Reservations are highly recommended, especially for dinner",
            "Try their tasting menu for a complete gastronomic experience",
            "Request a window table for the best river views"
          ],
          website: "https://www.maior.pt",
          images: ["https://images.pexels.com/photos/4580112/pexels-photo-4580112.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        evening: [{
          title: "Casino Lisboa",
          desc: "Lisbon's premier gaming and entertainment destination, featuring a wide range of table games, slot machines, restaurants, and live shows in a modern riverside setting.",
          lat: 38.7640,
          lng: -9.0975,
          phone: "+351 21 892 9000",
          hours: "15:00-03:00 (Sun-Thu), 16:00-04:00 (Fri-Sat)",
          price: "Entry: €5 (18+ only, ID required)",
          tips: [
            "Dress code: Smart casual (no shorts, flip-flops, or sportswear)",
            "Visit the rooftop bar for panoramic views of the city",
            "Check the schedule for concerts and special events"
          ],
          website: "https://www.casinolisboa.pt",
          images: ["https://images.pexels.com/photos/3279695/pexels-photo-3279695.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }]
      }
    }
  ],
  Porto: [
    {
      label: "Premium Porto Wine Experience",
      city: "Porto",
      isPrivateTour: true,
      tourId: "porto-premium",
      slots: {
        allDay: [{
          ...privateTours.porto,
          type: 'tour',
          isPrivate: true,
          pois: privateTours.porto.detailedItinerary.flatMap(section => section.pois),
          display: {
            badge: "Private Tour",
            badgeColor: "#4f46e5",
            icon: "wine",
            highlights: privateTours.porto.highlights,
            detailedSchedule: privateTours.porto.detailedItinerary,
            contactInfo: {
              phone: "+351 123 456 789",
              email: "tours@portoguides.com"
            }
          },
          duration: privateTours.porto.duration,
          price: privateTours.porto.price,
          includes: privateTours.porto.includes,
          excludes: privateTours.porto.excludes,
          meetingPoint: privateTours.porto.meetingPoint,
          cancellationPolicy: privateTours.porto.cancellationPolicy
        }]
      },
      description: privateTours.porto.description,
      tips: [
        "Wear comfortable shoes for walking on cobblestone streets",
        "Bring a light jacket as it can get breezy by the river",
        "Don't forget your camera for the stunning views"
      ]
    },
    {
      label: "Riverside Porto",
      city: "Porto",
      slots: {
        morning: [{
          title: "Ribeira Square (Praça da Ribeira)",
          desc: "The vibrant heart of Porto's historic center and a UNESCO World Heritage Site, where colorful buildings, lively cafés, and the Douro River create one of Portugal's most picturesque settings, with the iconic Dom Luís I Bridge as its stunning backdrop.",
          lat: 41.1400,
          lng: -8.6115,
          hours: "24/7 (best visited during daylight)",
          price: "Free (cafés and restaurants have their own pricing)",
          tips: [
            "Visit early in the morning for the best light and fewest crowds",
            "Try a traditional francesinha sandwich at one of the local restaurants",
            "Take a river cruise from the nearby docks for a different perspective",
            "Evening brings street performers and a lively atmosphere"
          ],
          images: ["https://images.pexels.com/photos/30954862/pexels-photo-30954862/free-photo-of-scenic-view-of-porto-s-dom-luis-i-bridge-and-douro-river.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        lunch: [{
          title: "Cais de Gaia",
          desc: "Charming riverside district across the Douro River from Porto, world-famous for its historic Port wine cellars, scenic waterfront promenade, and breathtaking views of Porto's skyline and the Dom Luís I Bridge.",
          lat: 41.1381,
          lng: -8.6129,
          hours: "Cellars generally 10:00-18:00, Restaurants until late",
          price: "Tastings from €10-25, Meals €15-40",
          tips: [
            "Visit Graham's or Taylor's for excellent wine tours and tastings",
            "Try a tasting flight to sample different Port styles (Ruby, Tawny, Vintage)",
            "Take the cable car for spectacular aerial views of the river and city",
            "Best photo spots along the waterfront at sunset"
          ],
          website: "https://www.visitgaia.pt/en/",
          images: ["https://images.pexels.com/photos/17276771/pexels-photo-17276771/free-photo-of-the-beautiful-streets-and-architecture-in-porto-portugal.jpeg"]
        }],
        afternoon: [{
          title: "Dom Luís I Bridge",
          desc: "Iconic double-deck metal arch bridge spanning the Douro River, designed by a student of Gustave Eiffel, offering breathtaking panoramic views of Porto and Vila Nova de Gaia from its upper level, 45 meters above the river.",
          lat: 41.1405,
          lng: -8.6110,
          hours: "Pedestrian access 24/7 (upper level closes at night during bad weather)",
          price: "Free",
          tips: [
            "Walk across the upper level for the most spectacular views (172m long)",
            "Be cautious of trams that share the upper level with pedestrians",
            "Visit at sunset for incredible photo opportunities",
            "The lower level is less crowded and leads directly to the port wine cellars"
          ],
          images: ["https://images.pexels.com/photos/2549573/pexels-photo-2549573.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        dinner: [{
          title: "Brasão Coliseu",
          desc: "Renowned restaurant serving Porto's famous francesinha sandwich in a stunning setting.",
          lat: 41.1490,
          lng: -8.6105,
          phone: "+351 22 201 1769",
          hours: "12:00-23:30 (Mon-Sat), 12:00-22:30 (Sun)",
          price: "€€",
          tips: ["Try their signature francesinha with a local beer", "Reservations recommended", "Save room for dessert - the chocolate mousse is divine"],
          website: "https://www.brasao.com.pt"
        }],
        evening: [{
          title: "Gaia Cable Car (Teleférico de Gaia)",
          desc: "Breathtaking aerial cable car ride offering spectacular 360° panoramic views of Porto's historic center, the Douro River, and the iconic Dom Luís I Bridge, connecting the riverside area to the upper level of the bridge.",
          lat: 41.1385,
          lng: -8.6125,
          phone: "+351 22 786 4300",
          hours: "10:00-20:00 (varies by season, check website for exact times)",
          price: "€10 (round trip), €7 (one way), Children 4-12: €5/€3.50",
          tips: [
            "Best time to ride is just before sunset for golden hour views",
            "Combination tickets available with port wine cellars and river cruises",
            "The 5-minute ride covers 600 meters with stunning river and city views",
            "Wheelchair accessible cabins available"
          ],
          website: "https://www.telefericodegaia.pt/",
          images: ["https://images.pexels.com/photos/32335363/pexels-photo-32335363/free-photo-of-cargo-ship-and-cable-cars-over-the-rhine-river.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }]
      }
    },
    {
      label: "Historic Porto",
      city: "Porto",
      slots: {
        morning: [{
          title: "Livraria Lello",
          desc: "One of the world's most beautiful bookstores, famous for its stunning neo-Gothic architecture, intricate woodwork, the iconic red staircase, and its rumored inspiration for J.K. Rowling's Harry Potter series.",
          lat: 41.1466,
          lng: -8.6147,
          phone: "+351 22 002 0377",
          hours: "09:30-19:00 (Mon-Sat), 10:00-19:00 (Sun)",
          price: "€8 (includes €5 voucher for book purchases)",
          tips: [
            "Arrive early or book tickets online to avoid long queues",
            "The ticket price includes a discount on any book purchase",
            "Visit the second floor for the best photo opportunities",
            "The bookstore can get crowded - consider visiting during off-peak hours"
          ],
          website: "https://www.livrarialello.pt",
          images: ["https://images.pexels.com/photos/10830916/pexels-photo-10830916.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        lunch: [{
          title: "Mercado do Bolhão",
          desc: "Historic market hall in central Porto, known for its beautiful 19th-century Neoclassical facade and vibrant atmosphere, offering fresh local produce, traditional Portuguese foods, and authentic market experience.",
          lat: 41.1460,
          lng: -8.6100,
          phone: "+351 22 332 4260",
          hours: "08:00-20:00 (Mon-Sat), 08:00-18:00 (Sun)",
          price: "Free entry, food prices vary",
          tips: [
            "Try the famous Portuguese custard tarts (pastéis de nata) from one of the bakeries",
            "Visit in the morning for the freshest produce and liveliest atmosphere",
            "Don't miss the upper floor for a great view of the market's interior",
            "Many vendors accept credit cards, but it's good to have some cash"
          ],
          website: "https://www.mercadodobolhao.pt/",
          images: ["https://images.pexels.com/photos/17309560/pexels-photo-17309560/free-photo-of-bolhao.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        afternoon: [{
          title: "Clérigos Tower (Torre dos Clérigos)",
          desc: "Iconic 18th-century Baroque bell tower standing 75.6 meters tall, offering the best panoramic views of Porto's historic center and the Douro River from its 240-step spiral staircase.",
          lat: 41.1456,
          lng: -8.6139,
          phone: "+351 22 200 1729",
          hours: "09:00-19:00 (last admission 30 min before closing)",
          price: "€8 (includes tower and church), Students/Seniors: €5, Children under 10: free",
          tips: [
            "Climb early in the morning or late afternoon to avoid crowds and heat",
            "The narrow spiral staircase can be challenging - take your time",
            "Visit the adjacent Clérigos Church (included in ticket) with its beautiful Baroque interior",
            "The top offers 360° views - perfect for photography"
          ],
          website: "https://torreclerigos.pt/",
          images: ["https://images.pexels.com/photos/15585441/pexels-photo-15585441/free-photo-of-baroque-clerigos-church.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        dinner: [{ title: "Cantinho do Avillez", desc: "Modern Portuguese.", lat: 41.1450, lng: -8.6150 }],
        evening: [{
          title: "Rua Galerias de Paris",
          desc: "Porto's most famous nightlife street, lined with trendy bars, clubs, and restaurants in beautifully restored 19th-century buildings, offering a vibrant atmosphere that lasts well into the night.",
          lat: 41.1455,
          lng: -8.6090,
          hours: "Bars: 20:00-04:00, Clubs: 23:00-06:00 (typically)",
          price: "€€-€€€ (varies by establishment)",
          tips: [
            "The street comes alive after 11 PM, with peak hours around 1-3 AM",
            "Try a 'francesinha' at one of the late-night restaurants",
            "Weekends are busiest - go early to avoid long lines at popular spots",
            "Many places have live music - check local listings for events"
          ],
          images: ["https://images.pexels.com/photos/32411320/pexels-photo-32411320/free-photo-of-charming-european-street-with-cyclists.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }]
      }
    },
    {
      label: "Artistic Porto",
      city: "Porto",
      slots: {
        morning: [{
          title: "Serralves Museum",
          desc: "Portugal's leading contemporary art museum, set within the stunning Serralves Park, featuring thought-provoking exhibitions, striking architecture, and beautifully landscaped gardens.",
          lat: 41.1693,
          lng: -8.6420,
          phone: "+351 22 615 6500",
          hours: "10:00-19:00 (Tue-Fri), 10:00-20:00 (Sat-Sun), Closed Mon",
          price: "Museum: €12, Park: €10, Combined: €20, Free on 1st Sun of month 10:00-13:00",
          tips: [
            "Allocate at least 2-3 hours to explore both the museum and gardens",
            "The rooftop offers fantastic views of the park and city",
            "Free guided tours available - check the schedule at the entrance",
            "The Art Deco Casa de Serralves (villa) is a must-see within the park"
          ],
          website: "https://www.serralves.pt/",
          images: ["https://images.pexels.com/photos/700413/pexels-photo-700413.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        lunch: [{
          title: "Casa da Música",
          desc: "Striking contemporary concert hall designed by Rem Koolhaas, known for its bold geometric architecture and world-class acoustics, featuring a restaurant with views of Porto's skyline.",
          lat: 41.1616,
          lng: -8.6300,
          phone: "+351 22 012 0220",
          hours: "Café: 10:00-19:00, Restaurant: 12:30-15:00, 19:30-23:00 (check website for concert days)",
          price: "Café: €€, Restaurant: €€€, Concert tickets vary",
          tips: [
            "Take a guided tour to see the stunning interior and learn about the architecture",
            "The rooftop terrace offers panoramic views of the city",
            "Check the schedule for free lunchtime concerts (usually on Sundays)",
            "The restaurant serves contemporary Portuguese cuisine with a creative twist"
          ],
          website: "https://www.casadamusica.com/",
          images: ["https://images.pexels.com/photos/7017165/pexels-photo-7017165.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        afternoon: [{
          title: "Crystal Palace Gardens (Jardins do Palácio de Cristal)",
          desc: "Romantic 19th-century park offering panoramic views of the Douro River, featuring beautifully landscaped gardens, peacocks roaming freely, and the iconic Crystal Palace dome.",
          lat: 41.1535,
          lng: -8.6108,
          hours: "08:00-21:00 (summer), 08:00-19:00 (winter)",
          price: "Free admission",
          tips: [
            "Don't miss the viewpoint near the Almeida Garrett Library for stunning river views",
            "Look for the resident peacocks that roam freely through the gardens",
            "Visit the small but charming rose garden and the aromatic plants section",
            "The park often hosts temporary art exhibitions and cultural events"
          ],
          images: ["https://images.pexels.com/photos/15069229/pexels-photo-15069229/free-photo-of-porto-portugal.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }],
        dinner: [{ title: "O Gaveto", desc: "Seafood excellence.", lat: 41.1340, lng: -8.6700 }],
        evening: [{
          title: "Foz do Douro",
          desc: "Charming seaside district where the Douro River meets the Atlantic Ocean, known for its scenic promenade, dramatic rocky coastline, and beautiful sunsets over the Atlantic waves.",
          lat: 41.1383,
          lng: -8.7031,
          hours: "24/7 (best at sunset)",
          price: "Free (restaurants and bars have their own pricing)",
          tips: [
            "Walk along the promenade from the Douro mouth to the Felgueiras Lighthouse",
            "Try fresh seafood at one of the beachfront restaurants",
            "Visit the nearby Passeio Alegre Garden, a romantic 19th-century garden",
            "The area is particularly beautiful during sunset when the light reflects on the ocean"
          ],
          images: ["https://images.pexels.com/photos/2124892/pexels-photo-2124892.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"]
        }]
      }
    }
  ],
  Faro: [
    {
      label: "Historic Faro",
      city: "Faro",
      slots: {
        morning: [{
          title: "Old Town Faro",
          desc: "Charming historic center surrounded by ancient walls with cobbled streets and traditional architecture.",
          lat: 37.0147,
          lng: -7.9350,
          hours: "24/7 (sights have varying hours)",
          price: "Free (some attractions may charge)",
          tips: ["Visit the cathedral for great views", "Wander through the Arco da Vila gate", "Look for storks nesting on rooftops"]
        }],
        lunch: [{
          title: "Vila Adentro",
          desc: "Cozy restaurant serving authentic Algarve cuisine in a historic building.",
          lat: 37.0144,
          lng: -7.9322,
          phone: "+351 289 052 179",
          hours: "12:00-15:00, 19:00-22:00 (Wed-Mon), Closed Tue",
          price: "€€",
          tips: ["Try the cataplana (seafood stew)", "Ask for a table in the courtyard", "Local wines are excellent value"],
          website: "http://www.vilaadentro.pt"
        }],
        afternoon: [{
          title: "Praia de Faro",
          desc: "Beautiful sandy beach on a barrier island, connected to the mainland by a bridge.",
          lat: 36.9924,
          lng: -7.8509,
          hours: "24/7 (lifeguards in summer)",
          price: "Free (beach chair/umbrella rental extra)",
          tips: ["Take the bus or taxi from town (15 min)", "Beach bars serve great cocktails", "Waters are calm and great for swimming"]
        }],
        dinner: [{
          title: "Faaron Steakhouse",
          desc: "Popular restaurant known for its quality meats and seafood.",
          lat: 37.0180,
          lng: -7.9355,
          phone: "+351 289 803 018",
          hours: "18:30-22:30 (Tue-Sun), Closed Mon",
          price: "€€€",
          tips: ["Try the picanha (Brazilian cut steak)", "Reservations recommended in summer", "Good wine selection"],
          website: "https://www.faarons.com"
        }],
        evening: [{
          title: "Bar CheSsenta",
          desc: "Trendy bar with live music and a great atmosphere in the city center.",
          lat: 37.0155,
          lng: -7.9320,
          phone: "+351 962 512 302",
          hours: "21:00-04:00 (Wed-Sat), 18:00-02:00 (Sun-Tue)",
          price: "€",
          tips: ["Check their Facebook for live music schedule", "Try their signature cocktails", "Gets busy after midnight"]
        }]
      }
    },
    {
      label: "Nature Faro",
      city: "Faro",
      slots: {
        morning: [{ title: "Ria Formosa Tour", desc: "Lagoon islands.", lat: 36.9978, lng: -7.8205 }],
        lunch: [{ title: "Marisqueira Foz", desc: "Seafood by lagoon.", lat: 36.9980, lng: -7.8210 }],
        afternoon: [{ title: "Ilha Deserta", desc: "Remote beach.", lat: 36.9995, lng: -7.8510 }],
        dinner: [{ title: "Casa do Pescador", desc: "Fresh catch daily.", lat: 37.0200, lng: -7.9400 }],
        evening: [{ title: "Marina Walk", desc: "Evening stroll.", lat: 37.0158, lng: -7.9327 }]
      }
    },
    {
      label: "Cultural Faro",
      city: "Faro",
      slots: {
        morning: [{ title: "Igreja do Carmo", desc: "Baroque church.", lat: 37.0189, lng: -7.9296 }],
        lunch: [{ title: "Portas São Pedro", desc: "Café inside walls.", lat: 37.0175, lng: -7.9305 }],
        afternoon: [{ title: "Fortaleza Santa Catarina", desc: "Coastal fortress.", lat: 37.0132, lng: -7.9290 }],
        dinner: [{ title: "Taco Lounge", desc: "Tapas and cocktails.", lat: 37.0138, lng: -7.9353 }],
        evening: [{ title: "Old Town Walk", desc: "Historic ramparts.", lat: 37.0147, lng: -7.9350 }]
      }
    }
  ],
  Coimbra: [
    {
      label: "Historic Coimbra",
      city: "Coimbra",
      slots: {
        morning: [{
          title: "Biblioteca Joanina",
          desc: "Stunning baroque library at the University of Coimbra, known for its opulent decor and rare book collection.",
          lat: 40.2069,
          lng: -8.4245,
          imageUrl: 'https://images.pexels.com/photos/1296000/pexels-photo-1296000.jpeg?auto=compress&cs=tinysrgb&w=600',
          tips: [
            'Photography is not allowed inside',
            'Entry is by timed ticket - book in advance',
            'The bats that live in the library help preserve the books by eating insects'
          ]
        }],
        lunch: [{
          title: "University of Coimbra",
          desc: "One of the oldest universities in Europe, a UNESCO World Heritage site with stunning architecture and rich history.",
          lat: 40.2069,
          lng: -8.4245,
          imageUrl: 'https://images.pexels.com/photos/20427100/pexels-photo-20427100/free-photo-of-entrance-to-coimbra-university-in-portugal.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          tips: [
            'Visit the Joanina Library (ticket required)',
            'Don\'t miss the Royal Palace and the University Tower',
            'The view from the tower is spectacular'
          ]
        }],
        afternoon: [{
          title: "Sé Velha",
          desc: "The Old Cathedral of Coimbra, a magnificent example of Romanesque architecture in Portugal.",
          lat: 40.2089,
          lng: -8.4265,
          imageUrl: 'https://images.pexels.com/photos/17008557/pexels-photo-17008557/free-photo-of-interior-of-old-cathedral-in-coimbra.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          tips: [
            'Visit early to avoid crowds',
            'Don\'t miss the beautiful cloister',
            'Check the opening hours as they vary by season'
          ]
        }],
        evening: [{
          title: "Mondego Riverside",
          desc: "Scenic river walk along the beautiful Mondego River.",
          lat: 40.2027,
          lng: -8.4188,
          imageUrl: 'https://images.pexels.com/photos/11942020/pexels-photo-11942020.jpeg?auto=compress&cs=tinysrgb&w=600',
          tips: [
            'Perfect for an evening stroll',
            'Great spot for photography at sunset',
            'Several cafés nearby for a drink with a view'
          ]
        }]
      }
    }
  ],
  Sintra: [
    {
      label: "Premium Sintra & Pena Palace Tour",
      city: "Sintra",
      isPrivateTour: true,
      tourId: "sintra-premium",
      slots: {
        allDay: [{
          ...privateTours.sintra,
          type: 'tour',
          isPrivate: true,
          pois: privateTours.sintra.detailedItinerary.flatMap(section => section.pois),
          display: {
            badge: "Private Tour",
            badgeColor: "#4f46e5",
            icon: "castle",
            highlights: privateTours.sintra.highlights,
            detailedSchedule: privateTours.sintra.detailedItinerary,
            contactInfo: {
              phone: "+351 123 456 789",
              email: "tours@sintraguides.com"
            }
          },
          duration: privateTours.sintra.duration,
          price: privateTours.sintra.price,
          includes: privateTours.sintra.includes,
          excludes: privateTours.sintra.excludes,
          meetingPoint: privateTours.sintra.meetingPoint,
          cancellationPolicy: privateTours.sintra.cancellationPolicy
        }]
      },
      description: privateTours.sintra.description,
      tips: [
        "Wear comfortable walking shoes as there are many stairs",
        "Bring a light jacket as it's cooler in the mountains",
        "Visit on weekdays to avoid crowds"
      ]
    },
    // Regular Templates
    {
      label: "Magical Sintra",
      city: "Sintra",
      slots: {
        morning: [{
          title: "Pena Palace", 
          desc: "A 19th-century Romanticist castle and UNESCO World Heritage Site, known for its vibrant colors, stunning architecture, and panoramic views of the Sintra mountains and Atlantic Ocean.",
          lat: 38.7879,
          imageUrl: 'https://images.pexels.com/photos/9021550/pexels-photo-9021550.jpeg?auto=compress&cs=tinysrgb&w=600',
          tips: [
            'Arrive early to avoid crowds',
            'Wear comfortable shoes for walking on uneven surfaces',
            'Visit the terraces for the best photo opportunities'
          ],
          lng: -9.3900,
          hours: "09:30-18:30 (summer), 10:00-18:00 (winter)",
          price: "€14 (Palace & Park), €7.50 (Park only)",
          tips: [
            "Arrive early to avoid crowds, especially in summer",
            "Wear comfortable shoes for walking on cobblestones",
            "Visit the surrounding park for beautiful gardens and hidden gems",
            "The walk up is steep - consider taking the shuttle bus"
          ],
          images: ["https://images.pexels.com/photos/9021550/pexels-photo-9021550.jpeg?auto=compress&cs=tinysrgb&w=600"]
        }],
        lunch: [],
        afternoon: [
          {
            title: "Sintra Historic Center",
            desc: "The charming historic center of Sintra, a UNESCO World Heritage site, with its cobbled streets, traditional shops, and the iconic Sintra National Palace with its distinctive twin chimneys.",
            lat: 38.7975,
            lng: -9.3903,
            imageUrl: 'https://images.pexels.com/photos/24407903/pexels-photo-24407903/free-photo-of-landscape-with-sintra-national-palace-in-portugal.jpeg?auto=compress&cs=tinysrgb&w=600',
            hours: "09:30-19:00 (attractions), 24/7 (outdoor areas)",
            price: "Free (outdoor areas), €10 (National Palace)",
            tips: [
              "Visit the Sintra National Palace with its famous twin chimneys",
              "Try the local queijadas (sweet cheese pastries)",
              "Explore the narrow streets and traditional shops",
              "The town is especially magical in the evening when day-trippers have left",
              "Try the local pastry 'travesseiros' at Piriquita",
              "The Tourist Office provides excellent free maps"
            ]
          },
          {
            title: "Quinta da Regaleira",
            desc: "A UNESCO-listed estate featuring a romantic palace, lush gardens, and mysterious underground tunnels leading to the famous Initiation Well, a 27-meter deep spiral staircase with symbolic meaning.",
            lat: 38.7969,
            lng: -9.3966,
            imageUrl: 'https://images.pexels.com/photos/12813497/pexels-photo-12813497.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
            hours: "09:30-18:00 (summer), 10:00-17:30 (winter)",
            price: "€11 (adults), €5 (children 6-17)",
            tips: [
              "Don't miss the underground tunnels - bring a flashlight",
              "The Initiation Well is a must-see but can get crowded",
              "Allocate at least 2 hours to explore the extensive gardens",
              "The view from the palace tower is worth the climb"
            ]
          },
          {
            title: "Monserrate Palace",
            desc: "A stunning 19th-century Romantic palace surrounded by exotic gardens, featuring a unique blend of Gothic, Indian, and Moorish architectural influences.",
            lat: 38.7925,
            lng: -9.4192,
            imageUrl: 'https://media.istockphoto.com/id/514108355/photo/monserrate-palace.jpg?b=1&s=612x612&w=0&k=20&c=Y-2VGahf5MWYj8dNnSDy6ZM00qoqMlf7VHZ8grO9RZk=',
            hours: "09:30-18:00 (summer), 10:00-17:00 (winter)",
            price: "€8 (adults), €6.50 (seniors/students), Free (children under 6)",
            tips: [
              "The gardens are as impressive as the palace itself",
              "Less crowded than Pena Palace - great for photography",
              "Look for the fern garden and the Mexican garden",
              "The palace's interior features beautiful tile work and wood carvings"
            ]
          }
        ],
        dinner: [],
        evening: [
          {
            title: "Cabo da Roca",
            desc: "The westernmost point of mainland Europe, where the land ends and the sea begins. Stunning cliffs drop dramatically into the Atlantic Ocean, offering breathtaking sunset views.",
            lat: 38.7804,
            lng: -9.4989,
            imageUrl: 'https://images.pexels.com/photos/17832008/pexels-photo-17832008/free-photo-of-view-of-the-cabo-da-roca-lighthouse-on-the-coast-of-the-atlantic-ocean-in-portugal.jpeg?auto=compress&cs=tinysrgb&w=600',
            hours: "09:00-20:00 (visitor center)",
            price: "Free (parking €2/hour)",
            tips: [
              "Best visited at sunset for amazing photo opportunities",
              "Dress warmly - it's often windy and cooler than in Sintra",
              "Visit the small lighthouse and the stone cross marking the westernmost point",
              "The nearby Ursa Beach is a hidden gem for the adventurous"
            ]
          }
        ]
      }
    }
  ],
  Évora: [
    {
      label: "Ancient Évora",
      city: "Évora",
      slots: {
        morning: [{
          title: "Cromeleque dos Almendres",
          desc: "One of the most important megalithic sites in Europe, this impressive stone circle dates back to 6000-4000 BC. The 95 standing stones form an oval pattern and are believed to have been used for astronomical observations and religious ceremonies.",
          lat: 38.5566,
          lng: -8.0615,
          imageUrl: 'https://images.pexels.com/photos/11074268/pexels-photo-11074268.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          hours: "24/7 (daylight hours recommended)",
          price: "Free",
          tips: [
            'Best visited early morning or late afternoon for softer light and fewer visitors',
            'Wear comfortable shoes as the terrain is uneven',
            'Bring water and sun protection as there\'s little shade',
            'Consider a guided tour to learn about the site\'s astronomical significance',
            'Combine with a visit to nearby Menir dos Almendres for a complete prehistoric experience'
          ]
        }],
        lunch: [{
          title: "Taberna Típica Quarta-feira",
          desc: "Charming restaurant serving authentic Alentejo cuisine in a rustic setting with traditional decor.",
          lat: 38.5718,
          lng: -7.9075,
          hours: "12:30-15:00, 19:30-22:00 (Wed-Mon), Closed Tue",
          price: "€€",
          tips: [
            'Try the black pork (porco preto), an Alentejo specialty',
            'Pair your meal with a local Alentejo wine',
            'Save room for the traditional sericaia dessert'
          ]
        }],
        afternoon: [{
          title: "Temple of Diana",
          desc: "Remarkably well-preserved Roman temple dating back to the 1st century AD, making it one of the best-preserved Roman ruins in Portugal. The temple was dedicated to the Roman goddess Diana and stands as a testament to Évora's Roman past.",
          lat: 38.5715,
          lng: -7.9079,
          hours: "24/7 (exterior view)",
          price: "Free (exterior)",
          tips: [
            'Visit in the late afternoon for the best lighting on the columns',
            'The temple is beautifully illuminated at night',
            'Look for the medieval tower built into the temple structure'
          ]
        }],
        dinner: [{
          title: "Fialho",
          desc: "One of Évora's most renowned restaurants, offering classic Portuguese cuisine with Alentejo influences in an elegant setting.",
          lat: 38.5660,
          lng: -7.8940,
          hours: "12:30-15:00, 19:30-22:30 (Tue-Sat), 12:30-15:00 (Sun), Closed Mon",
          price: "€€€",
          tips: [
            'Reservations recommended, especially for dinner',
            'Try their famous açorda de camarão (bread and shrimp stew)',
            'Ask for wine pairing suggestions from their excellent selection of Alentejo wines'
          ]
        }],
        evening: [{
          title: "Praça do Giraldo",
          desc: "The vibrant heart of Évora, this beautiful square is surrounded by historic buildings, charming arcades, and lively cafés. The square comes alive in the evening with locals and visitors enjoying the pleasant atmosphere.",
          lat: 38.5726,
          lng: -7.9050,
          hours: "24/7",
          price: "Free",
          tips: [
            'Try a ginjinha (sour cherry liqueur) at one of the outdoor cafés',
            'Admire the 16th-century marble fountain with eight spouts',
            'Visit the nearby Igreja de Santo Antão for its beautiful interior'
          ]
        }]
      }
    }
  ],
  Braga: [
    {
      label: "Spiritual Braga",
      city: "Braga",
      slots: {
        morning: [{
          title: "Santuário do Bom Jesus do Monte",
          desc: "One of the most important pilgrimage sites in Portugal, famous for its monumental Baroque stairway that climbs 116 meters (381 ft) up to the church. The zigzagging staircase represents the Stations of the Cross, with chapels, fountains, and allegorical statues along the way.",
          lat: 41.5551,
          lng: -8.3770,
          imageUrl: 'https://images.pexels.com/photos/24705919/pexels-photo-24705919/free-photo-of-people-in-front-of-church-in-braga.jpeg',
          hours: "08:00-20:00 (summer), 09:00-19:00 (winter)",
          price: "Free (funicular €1.50 one way)",
          tips: [
            'Take the historic water-powered funicular (Elevador do Bom Jesus) for a unique experience',
            'Climb the famous zigzagging staircase for the full experience',
            'Visit the terrace behind the church for panoramic views of Braga',
            'Wear comfortable shoes for climbing the 577 steps',
            'Early morning offers the best light for photography'
          ]
        }],
        lunch: [{
          title: "A Brasileira",
          desc: "Iconic café in Braga's historic center, known for its beautiful Art Nouveau interior and traditional Portuguese cuisine.",
          lat: 41.5548,
          lng: -8.4217,
          hours: "08:00-20:00 (Mon-Sat), 09:00-20:00 (Sun)",
          price: "€€",
          tips: [
            'Try their famous francesinha sandwich',
            'Great spot for people-watching on the terrace',
            'Don\'t miss their pastel de nata'
          ]
        }],
        afternoon: [{
          title: "Sé de Braga (Braga Cathedral)",
          desc: "The oldest cathedral in Portugal, founded in the 11th century, showcasing an extraordinary blend of architectural styles from Romanesque to Manueline. The stunning façade features intricate carvings and the twin bell towers dominate Braga's skyline.",
          lat: 41.5454,
          lng: -8.4265,
          imageUrl: 'https://media.istockphoto.com/id/1278838341/photo/holy-cross-church-in-braga-portugal.jpg?b=1&s=612x612&w=0&k=20&c=hpJI2NG7kU_DplX82TtD1ucQObei9R6NOZmag-NIQKU=',
          hours: "09:30-12:30, 14:30-17:30 (Mon-Sat), 14:30-17:30 (Sun)",
          price: "€3 (Cathedral), €5 (Treasury and Choir)",
          tips: [
            'Visit the Chapel of the Kings with its 14th-century royal tombs',
            'Climb to the upper choir for a unique perspective of the nave',
            'Don\'t miss the 16th-century gilded organ in the main chapel',
            'Look for the 12th-century Romanesque south portal',
            'Check the schedule for occasional organ concerts'
          ]
        }],
        dinner: [{
          title: "Restaurante Tibães",
          desc: "Renowned restaurant offering traditional Minho cuisine in a charming setting near the historic Tibães Monastery.",
          lat: 41.5645,
          lng: -8.4177,
          hours: "12:00-15:00, 19:00-22:30 (Wed-Mon), Closed Tue",
          price: "€€-€€€",
          tips: [
            'Try the bacalhau à Brás (shredded cod with potatoes and eggs)',
            'Make a reservation for dinner',
            'Ask for local wine recommendations'
          ]
        }],
        evening: [{
          title: "Jardim de Santa Bárbara",
          desc: "Beautiful medieval garden next to the Archbishop's Palace, beautifully illuminated at night with a romantic atmosphere.",
          lat: 41.5476,
          lng: -8.4262,
          hours: "24/7",
          price: "Free",
          tips: [
            'Perfect for a peaceful evening stroll',
            'Great spot for photos of the illuminated Archbishop\'s Palace',
            'Visit the adjacent public library in the former Archbishop\'s Palace'
          ]
        }]
      }
    }
  ],
  Aveiro: [
    {
      label: "Canal Aveiro",
      city: "Aveiro",
      slots: {
        morning: [{
          title: "Aveiro Salt Pans",
          desc: "Discover the traditional salt pans of Aveiro, where sea salt has been harvested for centuries using age-old techniques in a beautiful natural setting.",
          lat: 40.6614,
          lng: -8.7208,
          imageUrl: 'https://images.pexels.com/photos/27098325/pexels-photo-27098325/free-photo-of-a-person-working-at-a-salt-flat.jpeg?auto=compress&cs=tinysrgb&w=600',
          hours: '09:00-18:00 (varies by season)',
          price: 'Free (guided tours available for a fee)',
          tips: [
            'Best visited in the morning when workers are harvesting salt',
            'Wear comfortable shoes as the ground can be uneven',
            'Bring a hat and sunscreen as there\'s little shade',
            'Try the local flor de sal (flower of salt) as a souvenir'
          ]
        }, {
          title: "Moliceiro Ride", 
          desc: "Colorful boat tour on traditional moliceiro boats through Aveiro's picturesque canals, often called the 'Venice of Portugal'.", 
          lat: 40.6405, 
          lng: -8.6538,
          imageUrl: 'https://media.istockphoto.com/id/1291398813/photo/aveiro.jpg?b=1&s=612x612&w=0&k=20&c=Olu1SaPr1FWDR6I1tQBeiFdGyEnXgJ5rI95f7AEFeVE=', 
          hours: '09:00-18:00 (summer), 10:00-17:00 (winter)', 
          price: '€10-15 per person', 
          tips: [
          'Best time is late afternoon for beautiful light on the colorful boats',
          'Trips last about 45 minutes to 1 hour',
          'Bring a light jacket as it can be breezy on the water',
          'Listen to the boatman\'s stories about Aveiro\'s history'
        ] }],
        lunch: [{ title: "O Bairro", desc: "Canal-side café.", lat: 40.6400, lng: -8.6530 }],
        afternoon: [{
          title: "Costa Nova Beach",
          desc: "Famous for its colorful striped fisherman's houses (palheiros) and beautiful sandy beaches, Costa Nova is a picturesque seaside destination perfect for a relaxing afternoon.",
          lat: 40.6119,
          lng: -8.7497,
          imageUrl: 'https://images.pexels.com/photos/4445317/pexels-photo-4445317.jpeg?auto=compress&cs=tinysrgb&w=600',
          hours: '24/7 (beach access)',
          price: 'Free (public beach)',
          tips: [
            'Walk along the beachfront promenade to see the famous striped houses',
            'Try local seafood at one of the beachfront restaurants',
            'Visit the nearby Barra Lighthouse, the tallest in Portugal',
            'Great spot for surfing and other water sports'
          ]
        }],
        dinner: [{ title: "Salpoente", desc: "Seafood restaurant.", lat: 40.6409, lng: -8.6480 }],
        evening: [{ 
          title: "Old Town Aveiro", 
          desc: "Stroll through the charming streets of Aveiro's historic center, admiring the colorful Art Nouveau buildings and picturesque canals that give the city its nickname 'Venice of Portugal'.", 
          lat: 40.6405, 
          lng: -8.6538,
          imageUrl: 'https://images.pexels.com/photos/32402749/pexels-photo-32402749/free-photo-of-charming-street-in-aveiro-portugal-with-colorful-buildings.jpeg?auto=compress&cs=tinysrgb&w=600',
          hours: '24/7',
          price: 'Free',
          tips: [
            'Best time to visit is late afternoon when the light is perfect for photography',
            'Look for the beautiful Art Nouveau buildings along Rua João Mendonça',
            'Visit the nearby Mercado do Peixe (Fish Market) for local atmosphere',
            'Try the local sweet treat \'ovos moles\' from a pastelaria'
          ]
        }]
      }
    }
  ],
  Albufeira: [
    {
      label: "Beach Day in Albufeira",
      city: "Albufeira",
      slots: {
        morning: [{ title: "Praia dos Pescadores", desc: "Central beach with golden cliffs.", lat: 37.0886, lng: -8.2511 }],
        lunch: [{ title: "Restaurante O Marinheiro", desc: "Seafood with ocean views.", lat: 37.0890, lng: -8.2515 }],
        afternoon: [{
          title: "Old Town Albufeira",
          desc: "Wander through the picturesque whitewashed streets of Albufeira's historic center, where traditional Portuguese charm meets vibrant local life. The area is dotted with colorful buildings, artisan shops, and inviting cafés.",
          lat: 37.0893,
          lng: -8.2508,
          imageUrl: 'https://images.pexels.com/photos/12228137/pexels-photo-12228137.jpeg?auto=compress&cs=tinysrgb&w=600',
          hours: '24/7 (shops and restaurants have individual hours)',
          price: 'Free to explore',
          tips: [
            'Visit the iconic Clock Tower (Torre do Relógio) for great photo opportunities',
            'Explore the narrow streets leading to the Miradouro do Pau da Bandeira viewpoint',
            'Try the local pastries at one of the traditional bakeries',
            'Evening is magical when the streets are lit with fairy lights',
            'Look for the traditional Portuguese pavement designs'
          ]
        }],
        dinner: [{ title: "Casa da Fonte", desc: "Traditional Portuguese cuisine.", lat: 37.0888, lng: -8.2520 }],
        evening: [{ title: "The Strip", desc: "Vibrant nightlife area.", lat: 37.1000, lng: -8.2333 }]
      }
    },
    {
      label: "Family Fun in Albufeira",
      city: "Albufeira",
      slots: {
        morning: [{ title: "Zoomarine", desc: "Marine-themed park with dolphin shows.", lat: 37.0936, lng: -8.3350 }],
        lunch: [{ title: "Restaurante O Pescador", desc: "Fresh seafood by the marina.", lat: 37.0880, lng: -8.2500 }],
        afternoon: [{ title: "Albufeira Marina", desc: "Modern marina with boat tours.", lat: 37.0885, lng: -8.2525 }],
        dinner: [{ title: "Vila Joya Beach Club", desc: "Beachfront dining.", lat: 37.0900, lng: -8.2530 }],
        evening: [{ title: "Praia da Oura", desc: "Evening beach walk.", lat: 37.0920, lng: -8.2400 }]
      }
    }
  ],
  Douro: [
    {
      label: "Premium Douro Valley Wine Experience",
      city: "Douro",
      isPrivateTour: true,
      tourId: "douro-premium",
      slots: {
        allDay: [{
          ...privateTours.douro,
          type: 'tour',
          isPrivate: true,
          pois: privateTours.douro.detailedItinerary.flatMap(section => section.pois),
          display: {
            badge: "Private Tour",
            badgeColor: "#4f46e5",
            icon: "wine",
            highlights: privateTours.douro.highlights,
            detailedSchedule: privateTours.douro.detailedItinerary,
            contactInfo: {
              phone: "+351 123 456 789",
              email: "tours@douroguides.com"
            }
          },
          duration: privateTours.douro.duration,
          price: privateTours.douro.price,
          includes: privateTours.douro.includes,
          excludes: privateTours.douro.excludes,
          meetingPoint: privateTours.douro.meetingPoint,
          cancellationPolicy: privateTours.douro.cancellationPolicy
        }]
      },
      description: privateTours.douro.description,
      tips: [
        "Wear comfortable shoes for walking in vineyards",
        "Bring a jacket as it can get breezy on the river",
        "Don't forget your camera for the stunning valley views"
      ]
    },
    {
      label: "Wine & River Cruise",
      city: "Douro",
      slots: {
        morning: [{
          title: "Pinhão",
          desc: "Charming riverside town in the heart of the Douro Valley, known for its beautiful railway station with azulejo tiles.",
          lat: 41.1918,
          lng: -7.5409,
          hours: "24/7",
          price: "Free",
          tips: ["Visit the train station to see the beautiful azulejo tiles", "Great spot for photos of the Douro River", "Several wine shops offer tastings"]
        }],
        lunch: [{
          title: "DOC Restaurante",
          desc: "Michelin-starred restaurant by Chef Rui Paula, offering modern Portuguese cuisine with stunning Douro River views.",
          lat: 41.0979,
          lng: -7.8071,
          phone: "+351 254 858 123",
          hours: "12:30-15:30, 19:30-22:30 (Wed-Mon), Closed Tue",
          price: "€€€",
          tips: ["Reservations highly recommended", "Try the tasting menu for a complete experience", "Great wine pairing options available"]
        }],
        afternoon: [{
          title: "Quinta do Crasto",
          desc: "Renowned wine estate offering tours and tastings with panoramic views of the Douro Valley.",
          lat: 41.1684,
          lng: -7.7285,
          phone: "+351 254 920 020",
          hours: "10:00-18:00 (Daily)",
          price: "€15-€50 per person",
          tips: ["Book tours in advance", "Don't miss the infinity pool with amazing views", "Try their famous LBV Port"],
          website: "https://www.quintadocrasto.pt"
        }],
        dinner: [{
          title: "Castas & Pratos",
          desc: "Elegant restaurant in a renovated railway warehouse, serving regional cuisine with an excellent wine selection.",
          lat: 41.1756,
          lng: -7.5872,
          phone: "+351 254 323 170",
          hours: "12:30-15:00, 19:30-22:00 (Wed-Mon), Closed Tue",
          price: "€€€",
          website: "https://www.castasepratos.com"
        }],
        evening: [{
          title: "Douro River Sunset Cruise",
          desc: "Relaxing boat tour to enjoy the stunning sunset over the Douro Valley's terraced vineyards.",
          lat: 41.1000,
          lng: -7.8000,
          price: "€25-€60 per person",
          tips: [
            "Best time is during golden hour",
            "Bring a light jacket as it can get breezy",
            "Many operators offer wine tasting during the cruise"
          ]
        }]
      }
    },
    {
      label: "Scenic Douro",
      city: "Douro",
      slots: {
        morning: [{ title: "Lamego", desc: "Historic town known for its baroque sanctuary and wine production.", lat: 41.1000, lng: -7.8000 }],
        lunch: [{ title: "Tasquinha da Quinta", desc: "Traditional Portuguese restaurant with local specialties.", lat: 41.0950, lng: -7.8100 }],
        afternoon: [{ title: "Peso da Régua", desc: "Gateway to the Douro Valley with excellent wine tourism facilities.", lat: 41.1667, lng: -7.7833 }],
        dinner: [{ title: "Rabelo Restaurant", desc: "Fine dining with panoramic views of the Douro River.", lat: 41.1700, lng: -7.7800 }],
        evening: [{ title: "Wine Tasting at Quinta da Pacheca", desc: "Evening wine tasting at a historic wine estate.", lat: 41.1500, lng: -7.8000 }]
      }
    }
  ],
  Lagos: [
    {
      label: "Coastal Lagos",
      city: "Lagos",
      slots: {
        morning: [{ title: "Ponta da Piedade", desc: "Breathtaking rock formations.", lat: 37.0790, lng: -8.6690 }],
        lunch: [{ title: "Casinha do Petisco", desc: "Local tapas and seafood.", lat: 37.1020, lng: -8.6730 }],
        afternoon: [{ title: "Dona Ana Beach", desc: "One of Algarve's most beautiful beaches.", lat: 37.0860, lng: -8.6680 }],
        dinner: [{ title: "Restaurante O Camilo", desc: "Cliff-top seafood.", lat: 37.0850, lng: -8.6670 }],
        evening: [{ title: "Lagos Marina", desc: "Evening stroll by the water.", lat: 37.1000, lng: -8.6730 }]
      }
    },
    {
      label: "Historic Lagos",
      city: "Lagos",
      slots: {
        morning: [{ title: "Lagos Old Town", desc: "Historic cobbled streets.", lat: 37.1020, lng: -8.6730 }],
        lunch: [{ title: "Tasca Jota", desc: "Traditional Portuguese dishes.", lat: 37.1015, lng: -8.6725 }],
        afternoon: [{ title: "Fort of Ponta da Bandeira", desc: "17th-century oceanfront fort.", lat: 37.1000, lng: -8.6710 }],
        dinner: [{ title: "Adega da Marina", desc: "Seafood and wine.", lat: 37.1005, lng: -8.6720 }],
        evening: [{ title: "Meia Praia", desc: "Sunset at the beach.", lat: 37.1100, lng: -8.6630 }]
      }
    }
  ],
  Sagres: [
    {
      label: "Wild West Algarve",
      city: "Sagres",
      slots: {
        morning: [{ title: "Cabo de São Vicente", desc: "Dramatic southwesternmost point of Europe.", lat: 37.0231, lng: -8.9967 }],
        lunch: [{ title: "A Tasca", desc: "Local cuisine with sea views.", lat: 37.0079, lng: -8.9434 }],
        afternoon: [{ title: "Fortaleza de Sagres", desc: "Historic fortress with ocean views.", lat: 37.0099, lng: -8.9375 }],
        dinner: [{ title: "A Eira do Mel", desc: "Traditional Algarve dishes.", lat: 37.0080, lng: -8.9450 }],
        evening: [{ title: "Praia do Tonel", desc: "Sunset at the beach.", lat: 37.0167, lng: -8.9500 }]
      }
    },
    {
      label: "Beach Day in Sagres",
      city: "Sagres",
      slots: {
        morning: [{ title: "Praia do Martinhal", desc: "Family-friendly beach.", lat: 37.0167, lng: -8.9333 }],
        lunch: [{ title: "Restaurante A Casinha", desc: "Beachfront dining.", lat: 37.0170, lng: -8.9330 }],
        afternoon: [{ title: "Praia do Beliche", desc: "Secluded cliff-surrounded beach.", lat: 37.0200, lng: -8.9400 }],
        dinner: [{ title: "Mareta Beach Bistro", desc: "Seafood by the sea.", lat: 37.0100, lng: -8.9380 }],
        evening: [{ title: "Sagres Harbor", desc: "Sunset views.", lat: 37.0079, lng: -8.9434 }]
      }
    }
  ]
};
